export const getSupportedVideoFormats = () => ['video/mp4', 'video/webm']

export const isVideoFormatSupported = file => {
  const supportedFormats = getSupportedVideoFormats()
  return supportedFormats.includes(file.type)
}

export const isVimeoUrl = url => {
  return url && url.includes('vimeo.com')
}

export const getVimeoEmbedUrl = url => {
  if (!isVimeoUrl(url)) return url

  const vimeoIdMatch = url.match(/vimeo\.com\/(\d+)/)
  if (vimeoIdMatch) {
    const params = [
      'controls=0',
      'autoplay=0',
      'loop=0',
      'byline=0',
      'portrait=0',
      'title=0',
      'transparent=0',
      'background=1',
      'muted=0',
      'playsinline=1'
    ].join('&')

    return `https://player.vimeo.com/video/${vimeoIdMatch[1]}?${params}`
  }
  return url
}

export const isGoogleStorageUrl = url => {
  return url && url.includes('storage.googleapis.com')
}

export const isDirectVideoUrl = url => {
  if (!url) return false

  const videoExtensions = ['.mp4', '.webm']
  const urlLower = url.toLowerCase()

  return videoExtensions.some(ext => urlLower.includes(ext)) || isGoogleStorageUrl(url)
}

export const shouldUseVideoTag = url => {
  return isDirectVideoUrl(url)
}

export const getVideoFormatName = mimeType => {
  const formatNames = {
    'video/mp4': 'MP4',
    'video/webm': 'WebM'
  }
  return formatNames[mimeType] || 'Unknown'
}

export const getSupportedVideoFormatsText = () => {
  return 'MP4, WebM'
}
